import styled from '@emotion/styled'
import { Radio } from 'antd'

export const StyledRadioGroup = styled(Radio.Group)<{ layout?: 'horizontal' | 'vertical'; activeColor?: string }>`
  display: flex;
  flex-direction: ${(props) => (props.layout === 'vertical' ? 'column' : null)};
  .ant-radio-button-wrapper {
    border-color: #353535;
    color: #d3d3d2;
    background-color: transparent;
    &-checked,
    &:hover,
    &:focus {
      background-color: #383e44;
      &:not(.ant-radio-button-wrapper-disabled) {
        color: #d3d3d2;
        &:first-of-type {
          border-color: #353535;
        }
        &:hover {
          border-color: #353535;
        }
      }
    }
    &:before {
      display: none;
    }
  }
`

export const StyledRadioButton = styled(Radio.Button)`
  border: 1px solid #353535;
  color: #d3d3d2;
  background-color: transparent;
  box-shadow: none;
  &.ant-radio-button-wrapper-checked,
  &:hover,
  &:focus {
    background-color: #383e44;
    border-color: #353535;
    &:not(.ant-radio-button-wrapper-disabled) {
      color: #d3d3d2;
      &:first-of-type {
        border-color: #353535;
      }
      &:hover {
        border-color: #353535;
      }
    }
  }
  &:not(:first-of-type):before {
    display: none;
  }
  &:first-of-type {
    border-left-color: #353535;
  }
  .ant-radio-button + span {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
`
